import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdFactCheck, MdFormatListBulleted } from "react-icons/md";
import CrmListPage from "components/app/crm/shared/CrmListPage";
import { columnDefs as baseColumns } from "components/app/authorization/report/Column";
import { getRoleUserPermissions, exportRoleUserPermissions } from "redux/authorization/roleSlice";
import { getActiveSites } from "redux/organization/siteSlice";

const columns = baseColumns.map((c) => ({ ...c, sortable: false }));

const TABS = [{ key: "all", label: "Overview", Icon: MdFormatListBulleted, thunk: getRoleUserPermissions, dataKey: "roleUserPermissionData" }];

const RoleUserPermissionReportPage = () => {
  const dispatch = useDispatch();
  const { activeData: activeSitesData = [] } = useSelector((s) => s.organization_site);

  useEffect(() => { dispatch(getActiveSites()); }, [dispatch]);

  const advancedFields = useMemo(() => [
    { key: "role_name",     label: "Role name",     type: "text",        paramKey: "role_name_cont",     tagName: "Role" },
    { key: "user_name",     label: "User name",     type: "text",        paramKey: "user_name_cont",     tagName: "User" },
    { key: "full_name",     label: "Full of name",  type: "text",        paramKey: "full_name_cont",     tagName: "Full name" },
    { key: "subject_class", label: "Subject class", type: "text",        paramKey: "subject_class_cont", tagName: "Subject" },
    { key: "action",        label: "Action",        type: "text",        paramKey: "action_cont",        tagName: "Action" },
    { key: "description",   label: "Description",   type: "text",        paramKey: "description_cont",    tagName: "Desc" },
    { key: "site",          label: "Site",          type: "multiselect", options: (activeSitesData || []).map((s) => ({ value: s.id, label: s.name })), paramKey: "site_id_in", tagName: "Site" },
    { key: "active",        label: "Active users only", type: "checkbox", paramKey: "active_true",        tagName: "Active" }
  ], [activeSitesData]);

  return (
    <CrmListPage
      title="Role · User · Permission Report"
      subtitle="Read-only matrix of role, user and permission assignments."
      Icon={MdFactCheck}
      reducerSelector={(s) => s.authorization_role}
      tabs={TABS}
      columns={columns}
      searchParamKey="role_name_or_user_name_or_subject_class_or_action_or_description_cont"
      searchPlaceholder="Role, user, subject, action..."
      advancedFields={advancedFields}
      advancedTitle="Filters for the permission report"
      exportThunk={exportRoleUserPermissions}
    />
  );
};

export default RoleUserPermissionReportPage;
